import DashboardTypes from './DashboardTypes';

const initialState = {
  numberOfView: [],
  numberUniqueVisitor: [],
  viewPerSection: [],
  topSearchTerms: []
};

export default function dashboardReducer (state = initialState, action) {
  const {
    type,
    payload
  } = action;
  let newState = { ...state };
  switch (type) {
    case DashboardTypes.GET_NUMBER_OF_VIEWS_SUCCESS: {
      newState.numberOfView = [...payload];
      return newState;
    }
    case DashboardTypes.GET_VIEWS_PER_SECTION_SUCCESS:
      newState.viewPerSection = [...payload];
      return newState;
    case DashboardTypes.GET_NUMBER_OF_UNIQUE_VISITOR_SUCCESS:
      newState.numberUniqueVisitor = [...payload];
      return newState;
    case DashboardTypes.GET_TOP_50_SEARCH_TERMS_SUCCESS:
      newState.topSearchTerms = [...payload];
      return newState;
    default:
      newState = state;
      break;
  }

  // return new state
  return newState;
}
